import * as React from 'react';
import { Outside } from '../../../services';
import * as styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function SelectDropdown(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose,
    insideRefs = _ref.insideRefs;
  return /*#__PURE__*/_jsx(Outside, {
    onOutside: onClose,
    active: true,
    insideRefs: insideRefs,
    children: /*#__PURE__*/_jsx("div", {
      className: styles['dropdown'],
      children: children
    })
  });
}